import {lazyWithRetry} from '../../../lazyWithRetry/lazyWithRetry';

export const LazyCampaignStatsGraph = lazyWithRetry(() => import('./campaignStatsGraph'));
